module.exports = __webpack_public_path__ + "img/98.c45d190b.jpg";